import { createLazyComponent } from '@muse-web/router'

export const AsyncGoogleOneTapContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'google-one-tap' */ './GoogleOneTapContainer'),
    'GoogleOneTapContainer',
)
